export default "__VITE_ASSET__CcFasjla__"